import WatchNow from './WatchNow';

function App() {
  return (
    <WatchNow />
  );
}

export default App;